/** Viewer session keys are mirrored to localStorage so preview tabs opened with noopener can read them. */

export function getViewerSessionId(token: string): string {
  return sessionStorage.getItem(`vs:${token}`) || localStorage.getItem(`vs:${token}`) || "";
}

export function getViewerViewId(token: string): string {
  return sessionStorage.getItem(`vid:${token}`) || localStorage.getItem(`vid:${token}`) || "";
}

export function getViewerEmail(token: string): string {
  return sessionStorage.getItem(`ve:${token}`) || localStorage.getItem(`ve:${token}`) || "";
}

export function setViewerSession(
  token: string,
  data: { sessionId: string; viewId: string; email?: string },
): void {
  sessionStorage.setItem(`vs:${token}`, data.sessionId);
  localStorage.setItem(`vs:${token}`, data.sessionId);
  sessionStorage.setItem(`vid:${token}`, data.viewId);
  localStorage.setItem(`vid:${token}`, data.viewId);
  if (data.email !== undefined) {
    sessionStorage.setItem(`ve:${token}`, data.email);
    localStorage.setItem(`ve:${token}`, data.email);
  }
}

export function setViewerViewId(token: string, viewId: string): void {
  sessionStorage.setItem(`vid:${token}`, viewId);
  localStorage.setItem(`vid:${token}`, viewId);
}

/** Drop restored session keys when the server rejects them (keep email optional). */
export function clearViewerSession(token: string, opts?: { keepEmail?: boolean }): void {
  sessionStorage.removeItem(`vs:${token}`);
  localStorage.removeItem(`vs:${token}`);
  sessionStorage.removeItem(`vid:${token}`);
  localStorage.removeItem(`vid:${token}`);
  if (!opts?.keepEmail) {
    sessionStorage.removeItem(`ve:${token}`);
    localStorage.removeItem(`ve:${token}`);
  }
}
